module.exports = {
  fetch: `query getVoices {
    voices {
      id
      name {
        en
      }
      description {
        en
      }
      ordinal
      avatarKey
      isDefault
      isInternational
    }
  }`
};
